module.exports = __webpack_public_path__ + "img/motorway_8x2.2fe1f572.svg";